:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

input,
select,
textarea {
  padding: 0;
  margin: 0;
  background-color: unset;
  border: unset;
  color: unset;
  font: unset;
  outline: unset;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  /**
   * @prop --ch-edit-auto-fill-background-color:
   * Define the background color when the edit is auto filled.
   * (#e8f0fe by default)
   */
  --ch-edit-auto-fill-background-color: #e8f0fe;
  /**
   * @prop --ch-edit__image-size:
   * Specifies the box size that contains the start and clear images of the
   * control.
   * @default 0.875em
   */
  --ch-edit__image-size: 0.875em;
  /**
    * @prop --ch-edit__background-image-size:
    * Specifies the size of the start and clear images of the control.
    * @default 100%
    */
  --ch-edit__background-image-size: 100%;
  /**
   * @prop --ch-edit-gap:
   * Specifies the gap between the start image and the value of the control.
   * @default 0px
   */
  --ch-edit-gap: 0px;
  /**
   * @prop --ch-placeholder-color:
   * Define the placeholder color when the edit does not have a value set.
   * (currentColor by default)
   */
  --ch-placeholder-color: currentColor;
  /**
   * @prop --ch-edit__clear-button-image:
   * Specifies the image for the clear button. 
   * @default url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"/></svg>')
   */
  --ch-edit__clear-button-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"/></svg>');
  /**
   * @prop --ch-edit__password-displayed-image:
   * Specifies the image for the show password button when the password is displayed.
   * @default url('data:image/svg+xml,<svg width="24" height="24" style="transform:scale(1.06) translateX(0.5px)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.7306 4.25083C20.065 4.58569 20.065 5.12817 19.7306 5.46303L5.64167 19.6777C5.4817 19.8397 5.26322 19.9304 5.03558 19.9293C4.68891 19.929 4.37651 19.7201 4.24389 19.3998C4.11127 19.0795 4.1845 18.7108 4.42948 18.4656L18.5184 4.25083C18.8533 3.91639 19.3957 3.91639 19.7306 4.25083ZM17.747 9.104L18.1589 9.38794C19.2025 10.1307 20.1595 10.9891 21.0114 11.9471C21.0114 11.9471 16.9746 16.7044 11.9886 16.7044C11.4534 16.686 10.9212 16.6171 10.399 16.4986L11.3253 15.5609C11.5437 15.6047 11.7658 15.6276 11.9886 15.6295C12.9711 15.6386 13.9166 15.2547 14.6146 14.5631C15.3126 13.8716 15.7052 12.9297 15.7052 11.9471C15.7056 11.7016 15.6826 11.4565 15.6366 11.2152L17.747 9.104ZM11.9886 7.1441C12.6002 7.14913 13.2096 7.21812 13.8068 7.34994L12.8005 8.35629C12.534 8.29641 12.2617 8.26573 11.9886 8.2648C9.96827 8.28363 8.34044 9.92676 8.34053 11.9471C8.34586 12.232 8.38035 12.5156 8.44345 12.7934L6.43074 14.8175V14.829C5.16463 14.011 4.01122 13.0306 3 11.9128C3 11.9128 7.03684 7.1441 11.9886 7.1441ZM14.5159 12.336C14.3441 13.402 13.5111 14.2396 12.446 14.4173L14.5159 12.336ZM11.7598 9.44269L9.47267 11.7299C9.57903 10.5135 10.5434 9.54906 11.7598 9.44269Z"/></svg>')
   */
  --ch-edit__password-displayed-image: url('data:image/svg+xml,<svg width="24" height="24" style="transform:scale(1.06) translateX(0.5px)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.7306 4.25083C20.065 4.58569 20.065 5.12817 19.7306 5.46303L5.64167 19.6777C5.4817 19.8397 5.26322 19.9304 5.03558 19.9293C4.68891 19.929 4.37651 19.7201 4.24389 19.3998C4.11127 19.0795 4.1845 18.7108 4.42948 18.4656L18.5184 4.25083C18.8533 3.91639 19.3957 3.91639 19.7306 4.25083ZM17.747 9.104L18.1589 9.38794C19.2025 10.1307 20.1595 10.9891 21.0114 11.9471C21.0114 11.9471 16.9746 16.7044 11.9886 16.7044C11.4534 16.686 10.9212 16.6171 10.399 16.4986L11.3253 15.5609C11.5437 15.6047 11.7658 15.6276 11.9886 15.6295C12.9711 15.6386 13.9166 15.2547 14.6146 14.5631C15.3126 13.8716 15.7052 12.9297 15.7052 11.9471C15.7056 11.7016 15.6826 11.4565 15.6366 11.2152L17.747 9.104ZM11.9886 7.1441C12.6002 7.14913 13.2096 7.21812 13.8068 7.34994L12.8005 8.35629C12.534 8.29641 12.2617 8.26573 11.9886 8.2648C9.96827 8.28363 8.34044 9.92676 8.34053 11.9471C8.34586 12.232 8.38035 12.5156 8.44345 12.7934L6.43074 14.8175V14.829C5.16463 14.011 4.01122 13.0306 3 11.9128C3 11.9128 7.03684 7.1441 11.9886 7.1441ZM14.5159 12.336C14.3441 13.402 13.5111 14.2396 12.446 14.4173L14.5159 12.336ZM11.7598 9.44269L9.47267 11.7299C9.57903 10.5135 10.5434 9.54906 11.7598 9.44269Z"/></svg>');
  /**
   * @prop --ch-edit__password-hidden-image:
   * Specifies the image for the show password button when the password is hidden.
   * @default url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 7C17.7497 7 22 11.988 22 11.988V12.024C22 12.024 17.7376 17 12.5 17C7.26236 17 3 11.988 3 11.988C3 11.988 7.25032 7 12.5 7ZM9.73369 9.28969C8.62237 10.3998 8.29261 12.0676 8.89837 13.5144C9.50412 14.9612 10.9259 15.9017 12.5 15.8969C14.6432 15.8903 16.3771 14.1583 16.3771 12.024C16.3771 10.4564 15.4282 9.0435 13.9735 8.44475C12.5187 7.84601 10.845 8.17956 9.73369 9.28969ZM12.5 9.3741C13.9669 9.38067 15.1544 10.5632 15.161 12.024C15.161 13.4875 13.9696 14.6739 12.5 14.6739C11.0304 14.6739 9.83904 13.4875 9.83904 12.024C9.83904 10.5605 11.0304 9.3741 12.5 9.3741Z"/></svg>')
   */
  --ch-edit__password-hidden-image: url('data:image/svg+xml,<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 7C17.7497 7 22 11.988 22 11.988V12.024C22 12.024 17.7376 17 12.5 17C7.26236 17 3 11.988 3 11.988C3 11.988 7.25032 7 12.5 7ZM9.73369 9.28969C8.62237 10.3998 8.29261 12.0676 8.89837 13.5144C9.50412 14.9612 10.9259 15.9017 12.5 15.8969C14.6432 15.8903 16.3771 14.1583 16.3771 12.024C16.3771 10.4564 15.4282 9.0435 13.9735 8.44475C12.5187 7.84601 10.845 8.17956 9.73369 9.28969ZM12.5 9.3741C13.9669 9.38067 15.1544 10.5632 15.161 12.024C15.161 13.4875 13.9696 14.6739 12.5 14.6739C11.0304 14.6739 9.83904 13.4875 9.83904 12.024C9.83904 10.5605 11.0304 9.3741 12.5 9.3741Z"/></svg>');
  display: grid;
  align-items: center;
  position: relative;
  grid-template: "ch-edit-content" 1fr/1fr;
  --ch-start-img: var(--ch-start-img--base);
}

:host(.ch-edit--cursor-text) {
  cursor: text;
}

:host:is(.gx-edit--auto-fill,
.gx-edit--auto-fill:focus-within,
.gx-edit--auto-fill:hover) {
  background-color: var(--ch-edit-auto-fill-background-color) !important;
}

.content {
  inline-size: 100%;
  cursor: inherit;
}
.content::placeholder {
  color: var(--ch-placeholder-color);
  opacity: 1;
}
.content::-ms-reveal {
  display: none;
}

.input,
.multiline-container {
  grid-area: ch-edit-content;
}

.multiline-container {
  display: grid;
  block-size: 100%;
  overflow: hidden;
}

:host(:hover) {
  --ch-start-img: var(--ch-start-img--hover, var(--ch-start-img--base));
}

:host(:active) {
  --ch-start-img: var(--ch-start-img--active, var(--ch-start-img--base));
}

:host(:focus) {
  --ch-start-img: var(
    --ch-start-img--focus,
    var(--ch-start-img--active, var(--ch-start-img--base))
  );
}

:host(:disabled) {
  pointer-events: none;
  --ch-start-img: var(--ch-start-img--disabled, var(--ch-start-img--base));
}
:host(:disabled) ::slotted([slot]) {
  pointer-events: all;
}

:host(.ch-edit-pseudo-img--start) {
  grid-template: "ch-edit-start-img-src ch-edit-content" 1fr/max-content 1fr;
}
:host(.ch-edit-pseudo-img--start) > .content {
  margin-inline-start: var(--ch-edit-gap);
}
:host(.ch-edit-pseudo-img--start)::before {
  grid-area: ch-edit-start-img-src;
  content: "";
  display: block;
  inline-size: var(--ch-edit__image-size);
  min-inline-size: var(--ch-edit__image-size);
  block-size: var(--ch-edit__image-size);
}

:host(.ch-edit-start-img-type--background)::before {
  background: no-repeat center/var(--ch-edit__background-image-size) var(--ch-start-img);
}

:host(.ch-edit-start-img-type--mask)::before {
  -webkit-mask: no-repeat center/var(--ch-edit__background-image-size) var(--ch-start-img);
  background-color: currentColor;
}

.multiline-floating {
  position: absolute;
  inset: 0;
  block-size: 100%;
  padding: inherit;
  resize: unset;
}
.multiline-inline {
  resize: unset;
}
.multiline-container {
  position: relative;
}

:host(.ch-edit--multiline) {
  overflow: hidden;
}

.hidden-multiline {
  inline-size: 100%;
  block-size: 100%;
  white-space: break-spaces;
  word-break: break-word;
  visibility: hidden;
}
.hidden-multiline::after {
  content: " ";
}

.readonly-date {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host(.ch-edit--editable-date) {
  cursor: pointer;
}

.null-date {
  opacity: 0;
}
.null-date:focus {
  opacity: 1;
}
.null-date:focus ~ .date-placeholder {
  opacity: 0;
}

.date-placeholder {
  display: grid;
  align-items: center;
  inset: 0;
  inset-inline-start: calc(var(--ch-edit__image-size) + var(--ch-edit-gap));
  position: absolute;
  padding: inherit;
  pointer-events: none;
  color: var(--ch-placeholder-color);
  opacity: 1;
}

.clear-button,
.show-password-button {
  display: inline-grid;
  align-items: center;
  justify-content: center;
}
.clear-button::before,
.show-password-button::before {
  content: "";
  display: block;
  inline-size: var(--ch-edit__image-size);
  min-inline-size: var(--ch-edit__image-size);
  block-size: var(--ch-edit__image-size);
  background-color: currentColor;
}

:host(.ch-edit--show-password-button) {
  grid-template: "ch-edit-content ch-edit-show-password-button" 1fr/1fr max-content;
}

:host(.ch-edit--show-password-button.ch-edit-pseudo-img--start) {
  grid-template: "ch-edit-start-img-src ch-edit-content ch-edit-show-password-button" 1fr/max-content 1fr max-content;
}

.show-password-button {
  grid-area: ch-edit-show-password-button;
}
.show-password-button::before {
  -webkit-mask: no-repeat center/var(--ch-edit__background-image-size) var(--ch-edit__password-displayed-image);
}
.show-password-button--hidden::before {
  -webkit-mask: no-repeat center/var(--ch-edit__background-image-size) var(--ch-edit__password-hidden-image);
}

[type=search]::-webkit-search-decoration,
[type=search]::-webkit-search-cancel-button {
  appearance: none;
}

:host(.ch-edit--clear-button) {
  grid-template: "ch-edit-content ch-edit-clear-button" 1fr/1fr max-content;
}

:host(.ch-edit--clear-button.ch-edit-pseudo-img--start) {
  grid-template: "ch-edit-start-img-src ch-edit-content ch-edit-clear-button" 1fr/max-content 1fr max-content;
}

.clear-button {
  grid-area: ch-edit-clear-button;
}
.clear-button::before {
  -webkit-mask: no-repeat center/var(--ch-edit__background-image-size) var(--ch-edit__clear-button-image);
}

.autofill:-webkit-autofill {
  animation: AutoFillStart 0.000001s;
  transition: background-color 99999999s 0s;
}
.autofill:not(:-webkit-autofill) {
  animation: AutoFillCancel 0.000001s;
}

@keyframes AutoFillStart {
  0% {
    visibility: inherit;
  }
}
@keyframes AutoFillCancel {
  0% {
    visibility: inherit;
  }
}